import * as yup from 'yup';

import i18n from '@src/app/i18n/config';

export const agreementsSchema = yup
  .object()
  .shape({
    personalDataAgreement: yup
      .bool()
      .required(i18n.t('COMMON:errors.required'))
      .oneOf([true], i18n.t('AGREEMENTS:errors.required')),
    specialOffersAgreement: yup
      .bool()
      .required(i18n.t('COMMON:errors.required')),
  })
  .required();
